import useEmailTableColumns from './useEmailTableColumns'
export default useEmailTableColumns
